import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, GovernmentProjectDetailReducer, GovernmentProjectDetailState } from './government-project-detail-reducer';

const GovernmentProjectDetailContext = createContext<GovernmentProjectDetailState | undefined>(undefined);
const GovernmentProjectDetailContextDispatchContext = createContext({} as any);

const GovernmentProjectDetailProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: GovernmentProjectDetailState = {
        detail: null,
        loading: false,
        error: null,
    };

    const [state, dispatch] = useReducer(GovernmentProjectDetailReducer, initialState);

    return (
        <GovernmentProjectDetailContext.Provider value={state}>
            <GovernmentProjectDetailContextDispatchContext.Provider value={dispatch}>
                {children}
            </GovernmentProjectDetailContextDispatchContext.Provider>
        </GovernmentProjectDetailContext.Provider>
    );
}

const useGovernmentProjectDetailState = () => {
    const context = useContext(GovernmentProjectDetailContext);
    if (context === undefined) {
        throw new Error('useGovernmentProjectDetailState must be used within a GovernmentProjectDetailProvider');
    }
    return context;
}

const useGovernmentProjectDetailDispatch = () => {
    const context = useContext(GovernmentProjectDetailContextDispatchContext);
    if (context === undefined) {
        throw new Error('useGovernmentProjectDetailDispatch must be used within a GovernmentProjectDetailProvider');
    }
    return context;
}

export { GovernmentProjectDetailProvider, useGovernmentProjectDetailState, useGovernmentProjectDetailDispatch, ACTION_TYPES };
